export const SHOW_ALERT_NOTIFICATION = 'containers/UpdatePlanPage/SHOW_ALERT_NOTIFICATION';
export const FOO = null;
